var map = {
	"./da-DK.json": "0b75",
	"./de-DE.json": "0e51",
	"./en-US.json": "992f",
	"./fr-FR.json": "e3aa",
	"./pl-PL.json": "dd69",
	"./pt-PT.json": "ab68",
	"./sv-SE.json": "42bd",
	"./zh-CN.json": "88e5",
	"./zh-TW.json": "f646"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a624";